/* Shipping Protection — Dawn — ID mode
   Global spinner persists until sections refresh completes
   - Checkbox stays stable; final state applied once after refresh
   - Global spinner overlay outside cart sections (not torn down)
   - Safe section refresh: replace ONLY [data-section-id] or #shopify-section-<handle>
*/
(function(){
  const CONFIG = {
    DEBUG: true,
    currencyCode: (Shopify.currency && Shopify.currency.active) || 'AUD',
    label: 'Shipping Protection',
    blurb: 'Protect your order from loss, theft, or damage in transit.',
    tiers: [
      { maxSubtotalCents:  8000,   variantId: 47020175753474, priceHint:  249 },
      { maxSubtotalCents: 15000,   variantId: 47020175786242, priceHint:  399 },
      { maxSubtotalCents: 25000,   variantId: 47020175819010, priceHint:  599 },
      { maxSubtotalCents: 40000,   variantId: 47020175851778, priceHint:  799 },
      { maxSubtotalCents: 60000,   variantId: 47020175884546, priceHint:  999 },
      { maxSubtotalCents: Infinity,variantId: 47020175917314, priceHint: 1199 }
    ],
    lineProperties: { "_sp": "1" },
    drawerAnchorSelectors: [
      '.cart-drawer__footer .totals','cart-drawer .totals','.cart-drawer .totals','.cart-drawer__footer'
    ],
    pageAnchorSelectors: [
      '.cart__footer .totals','cart-footer .totals','.cart__footer','cart-footer'
    ],
    knownHandles: ['main-cart-items','cart-footer','cart-drawer','cart-icon-bubble','cart-live-region-text']
  };

  const log = (...a)=>CONFIG.DEBUG&&console.log('[SP]',...a);
  const fmt = c=>new Intl.NumberFormat(undefined,{style:'currency',currency:CONFIG.currencyCode}).format((c||0)/100);

  const fetchCart = ()=>fetch('/cart.js',{credentials:'same-origin'}).then(r=>r.json());
  const addVariant=(id,qty=1,props=CONFIG.lineProperties)=>fetch('/cart/add.js',{
    method:'POST',credentials:'same-origin',
    headers:{'Content-Type':'application/json'},
    body:JSON.stringify({id,quantity:qty,properties:props})
  }).then(r=>r.json());
  const changeLine=(line,qty)=>fetch('/cart/change.js',{
    method:'POST',credentials:'same-origin',
    headers:{'Content-Type':'application/json'},
    body:JSON.stringify({line,quantity:qty})
  }).then(r=>r.json());

  const subtotalItemsOnly = cart => cart.items.reduce((s,i)=>s+i.final_line_price, 0);
  const findSpLines = cart => cart.items.map((it,idx)=>({it,idx})).filter(({it})=>it.properties && it.properties._sp==='1');
  const tierForSubtotal = sub => CONFIG.tiers.find(t=>sub<=t.maxSubtotalCents) || CONFIG.tiers.at(-1);
  const qsa = sels => { for (const s of sels){ const el=document.querySelector(s); if (el) return el; } return null; };

  let BUSY=false, EVENTS_BOUND=false, OBS=null, OBS_TIMER=null;

  // ---------- Global spinner (outside sections) ----------
  function ensureGlobalSpinner(){
    if (document.getElementById('sp-global-style')) return;
    const css = `
      html.sp-busy { cursor: progress; }
      #sp-global { position: fixed; inset: auto 16px 16px auto; z-index: 9999;
        display: none; align-items: center; gap:8px; padding:10px 12px; border-radius:10px;
        background: rgba(17,17,17,.85); color:#fff; font: 600 12px/1.2 system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
        box-shadow:0 6px 20px rgba(0,0,0,.25); }
      html.sp-busy #sp-global { display: inline-flex; }
      #sp-global .sp-dot { width:14px; height:14px; border-radius:50%;
        border:2px solid rgba(255,255,255,.35); border-top-color:#fff; animation: sp-rot .7s linear infinite; }
      @keyframes sp-rot { to { transform: rotate(360deg); } }
    `;
    const s = document.createElement('style'); s.id='sp-global-style'; s.textContent = css; document.head.appendChild(s);
    const wrap = document.createElement('div'); wrap.id='sp-global';
    wrap.innerHTML = `<span class="sp-dot"></span><span>Updating cart…</span>`;
    document.body.appendChild(wrap);
  }
  const showBusy = ()=>{ ensureGlobalSpinner(); document.documentElement.classList.add('sp-busy'); BUSY=true; };
  const hideBusy = ()=>{ document.documentElement.classList.remove('sp-busy'); BUSY=false; };

  // ---------- safe section refresh ----------
  const collectSectionIds = ()=>{
    const ids = new Set();
    document.querySelectorAll('[data-section-id]').forEach(el=>{
      const id = el.getAttribute('data-section-id'); if (id) ids.add(id);
    });
    CONFIG.knownHandles.forEach(h=>ids.add(h));
    return [...ids];
  };

  async function refreshCartSections(){
    const ids = collectSectionIds();
    if (!ids.length) return false;
    const url = `${(Shopify.routes && Shopify.routes.root)||'/'}cart?sections=${ids.join(',')}`;
    const res = await fetch(url,{credentials:'same-origin'});
    if (!res.ok) return false;
    let data=null; try{ data=await res.json(); }catch{ return false; }

    let swapped=false;
    for (const key in data){
      const html = data[key]; if (!html) continue;
      let target = document.querySelector(`[data-section-id="${key}"]`);
      if (!target) target = document.getElementById(`shopify-section-${key}`);
      if (target){ target.outerHTML = html; swapped = true; }
    }
    window.dispatchEvent?.(new CustomEvent('cart:refresh'));
    document.dispatchEvent?.(new CustomEvent('cart:refresh',{bubbles:true}));
    return swapped;
  }

  // ---------- template ----------
  const TEMPLATE = (checked, priceCents)=>`
    <div class="sp-protect totals__row" data-sp-mounted="1" style="grid-column:1/-1;">
      <label class="sp-protect__row">
        <input type="checkbox" class="sp-protect__chk"${checked?' checked':''}/>
        <div class="sp-protect__copy">
          <div class="sp-protect__title">${CONFIG.label}</div>
          <div class="sp-protect__blurb">${CONFIG.blurb}</div>
        </div>
        <div class="sp-protect__price"><span class="sp-price">${fmt(priceCents)}</span></div>
      </label>
    </div>`;

  const ensureMount = anchor=>{
    if (!anchor) return null;
    let m = anchor.querySelector('[data-sp-mounted="1"]');
    if (m) return m;
    anchor.insertAdjacentHTML('beforeend', TEMPLATE(false,0));
    return anchor.querySelector('[data-sp-mounted="1"]');
  };

  // ---------- render ----------
  const renderUI = async ()=>{
    if (BUSY) return; // don’t redraw mid-op, spinner is global
    const cart = await fetchCart();
    const subtotal = subtotalItemsOnly(cart);
    const tier = tierForSubtotal(subtotal);
    const spLines = findSpLines(cart);
    const checked = spLines.length>0;
    const priceCents = checked ? spLines[0].it.final_line_price : (tier.priceHint || 0);

    const drawerAnchor=qsa(CONFIG.drawerAnchorSelectors);
    const pageAnchor=qsa(CONFIG.pageAnchorSelectors);
    if (drawerAnchor){ const m=ensureMount(drawerAnchor); if (m) m.outerHTML = TEMPLATE(checked,priceCents); }
    if (pageAnchor){ const m=ensureMount(pageAnchor); if (m) m.outerHTML = TEMPLATE(checked,priceCents); }

    bindOnce();
  };

  // ---------- checkbox finalization helpers ----------
  const setCheckedFinal = (state)=>{
    document.querySelectorAll('.sp-protect__chk').forEach(chk=>{ chk.checked = state; });
  };
  const setWidgetPrice = cents=>{
    document.querySelectorAll('.sp-price').forEach(el=>el.textContent = fmt(cents));
  };

  // ---------- idempotent mutation + global spinner ----------
  async function applyDesired(desired){
    if (BUSY) return;
    showBusy();

    try{
      // 1) remove all SP lines
      let cart = await fetchCart();
      const lines = findSpLines(cart).sort((a,b)=>b.idx-a.idx);
      for (const {idx} of lines) await changeLine(idx+1, 0);

      // 2) add correct tier if desired
      cart = await fetchCart();
      const tier = tierForSubtotal(subtotalItemsOnly(cart));
      if (desired){
        await addVariant(tier.variantId, 1, CONFIG.lineProperties);
      }

      // 3) refresh sections + fetch latest in parallel
      const [swapped, latest] = await Promise.all([refreshCartSections(), fetchCart()]);

      // 4) finalize once after refresh
      const sp = findSpLines(latest);
      const finalOn = sp.length>0;
      setCheckedFinal(finalOn);
      setWidgetPrice(finalOn ? sp[0].it.final_line_price : (tier.priceHint||0));

      if (!swapped && location.pathname.replace(/\/+$/,'')==='/cart') location.reload();
    }catch(err){
      console.error('[SP] error', err);
    }finally{
      hideBusy();           // spinner stays until AFTER refresh/reads complete
      renderUI();           // light redraw for the new DOM
    }
  }

  // ---------- events ----------
  const onClick = async (e)=>{
    const input = e.target.closest('.sp-protect__chk');
    const label = !input ? e.target.closest('label.sp-protect__row') : null;
    if (!input && !label) return;
    if (BUSY){ e.preventDefault(); e.stopPropagation(); return; }

    e.preventDefault(); e.stopPropagation();

    // decide from real cart
    const cart = await fetchCart();
    const desired = !(findSpLines(cart).length>0);

    // don’t toggle here; spinner turns on and holds globally
    await applyDesired(desired);
  };

  const onKeydown = async (e)=>{
    const el = e.target.closest('.sp-protect__chk, label.sp-protect__row');
    if (!el) return;
    if (e.key!==' ' && e.key!=='Enter') return;
    if (BUSY){ e.preventDefault(); e.stopPropagation(); return; }
    e.preventDefault(); e.stopPropagation();

    const cart = await fetchCart();
    const desired = !(findSpLines(cart).length>0);
    await applyDesired(desired);
  };

  const bindOnce = ()=>{
    if (EVENTS_BOUND) return;
    EVENTS_BOUND = true;
    document.addEventListener('click', onClick, true);
    document.addEventListener('keydown', onKeydown, true);
  };

  // ---------- observers ----------
  const startObservers=()=>{
    if (OBS) return;
    OBS = new MutationObserver(()=>{
      if (BUSY) return; // spinner showing; don’t redraw
      clearTimeout(OBS_TIMER); OBS_TIMER = setTimeout(renderUI, 80);
    });
    ['.cart-drawer','.cart__footer','cart-footer','cart-drawer'].forEach(sel=>{
      const el=document.querySelector(sel);
      if (el) OBS.observe(el,{childList:true,subtree:true});
    });
    document.addEventListener('cart:refresh', ()=>{ if (!BUSY) renderUI(); });
    document.addEventListener('shopify:section:load', ()=>{ if (!BUSY) renderUI(); });
    document.addEventListener('shopify:section:unload', ()=>{ if (!BUSY) renderUI(); });
  };

  document.addEventListener('DOMContentLoaded', ()=>{
    ensureGlobalSpinner();
    renderUI();
    startObservers();
  });
})();
